import { useSyncExternalStore } from 'react';
import { SPLIT_LAYOUT_MIN_WIDTH } from '../constants/breakpoints';

const query = `(min-width: ${SPLIT_LAYOUT_MIN_WIDTH}px)`;

function subscribe(listener: () => void): () => void {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return () => {};
  }

  const list = window.matchMedia(query);
  list.addEventListener('change', listener);
  return () => list.removeEventListener('change', listener);
}

function getSnapshot(): boolean {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return false;
  }

  return window.matchMedia(query).matches;
}

/**
 * Whether the viewport fits a list and its detail side by side. A tablet in
 * portrait leaves the detail pane too narrow to read, so it keeps the overlay.
 */
export function useSplitLayout(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
